import {Grid, Stack, Typography, styled} from '@mui/material';
import {Text} from 'App';
import {RoundedButton} from 'components';
import {useTranslation} from 'react-i18next';
import {blue} from 'styles/color';

const DownloadButton = ({icon, actionText, targetText, ...props}) => {
  const {i18n} = useTranslation();
  return (
    <StyledRoundedButton variant="contained" {...props}>
      <Grid container alignItems="center">
        <Grid
          item
          xs={3}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <img src={icon} alt="" style={{maxWidth: '40px'}} />
        </Grid>
        <Grid item xs={9} style={{paddingLeft: 5}}>
          {i18n.language == 'hi-IN' || i18n.language == 'ja-JP' ? (
            <Stack>
              <Text
                variant="h3regular"
                textAlign="left"
                style={{marginBottom: 5}}>
                {targetText}
              </Text>
              <StyledTypography textAlign="left">{actionText}</StyledTypography>
            </Stack>
          ) : (
            <Stack>
              <StyledTypography textAlign="left">{actionText}</StyledTypography>
              <Text variant="h3regular" textAlign="left" style={{marginTop: 5}}>
                {targetText}
              </Text>
            </Stack>
          )}
        </Grid>
      </Grid>
    </StyledRoundedButton>
  );
};

const StyledRoundedButton = styled(RoundedButton)(({theme}) => ({
  background: theme.palette.common.black,
  color: '#fff',
  width: 225,
  height: theme.spacing(7.5),
  paddingRight: theme.spacing(0.75),
  paddingLeft: theme.spacing(1.25),
  borderRadius: 10,
  [theme.breakpoints.down('md')]: {},
  [theme.breakpoints.down('sm')]: {
    height: theme.spacing(7.5),
  },
  [theme.breakpoints.down('xs')]: {
    height: theme.spacing(7.5),
  },
  border: '2px solid #898989',
  '&:hover': {
    backgroundColor: '#000',
  },
}));

const StyledTypography = styled(Typography)(({theme}) => ({
  fontSize: '12px',
  lineHeight: '12px',
  fontWeight: 400,
  width: theme.spacing(20),
}));

export {DownloadButton};
